export const POST_SAVE_JOB_REQUEST = 'POST_SAVE_JOB_REQUEST'
export const POST_SAVE_JOB_SUCCESS = 'POST_SAVE_JOB_SUCCESS'
export const POST_SAVE_JOB_FAILED = 'POST_SAVE_JOB_FAILED'
